import { Link } from "react-router-dom";

const HomePage = () => {
  return (
    <>
      <nav className="home-nav" data-testid="home-nav">
        <Link className="nav-logo" to="/" data-testid="nav-logo">
          <img src="/ruler-icon.png" alt="" className="nav-logo-icon-img" />
          <span className="nav-logo-text">Kids Size Finder</span>
        </Link>
        <div className="nav-links">
          <Link to="/privacy" data-testid="nav-privacy-link">Privacy Policy</Link>
          <Link to="/terms" data-testid="nav-terms-link">Terms of Service</Link>
          <a href="mailto:support@kidssizefinder.com" data-testid="nav-support-link">Support</a>
        </div>
      </nav>

      <section className="hero" data-testid="hero-section">
        <div className="hero-badge">✨ Free — no subscription</div>

        <h1>Find your child's size across <span>36+ brands</span></h1>

        <p className="hero-sub">
          Stop guessing. Enter your child's measurements and get the right size for any brand — in seconds.
        </p>

        <div className="store-badges">
          <a
            href="https://apps.apple.com/us/app/kids-size-finder/id6763076022"
            className="store-badge-link"
            aria-label="Download on the App Store"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="appstore-badge"
          >
            <img src="/badge-appstore.png" alt="Download on the App Store" className="store-badge-img" />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.outgrow.kidssizefinder"
            className="store-badge-link"
            aria-label="Get it on Google Play"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="googleplay-badge"
          >
            <img src="/badge-googleplay.png" alt="Get it on Google Play" className="store-badge-img" />
          </a>
        </div>
        <p className="free-note">Free · No subscription · 36+ brands</p>

        <div className="screenshot-wrap">
          <div className="screenshot-phone" data-testid="screenshot-phone">
            <div className="screenshot-notch"></div>
            <img
              src="/login-screenshot.png"
              alt="Kids Size Finder login screen"
              className="screenshot-img"
              data-testid="screenshot-image"
            />
          </div>
        </div>
      </section>

      <section className="features" data-testid="features-section">
        <div className="feature-card">
          <span className="feature-icon">📏</span>
          <div className="feature-title">36+ verified brands</div>
          <p className="feature-desc">
            Carter's, H&M, Zara, Old Navy, Gap Kids, Next, Tu, Primark and many more — all with verified size charts.
          </p>
        </div>
        <div className="feature-card">
          <span className="feature-icon">⚡</span>
          <div className="feature-title">Results in seconds</div>
          <p className="feature-desc">
            Enter height and weight, pick a brand, get the right size instantly — plus how long it will fit.
          </p>
        </div>
        <div className="feature-card">
          <span className="feature-icon">📈</span>
          <div className="feature-title">Auto-updating profiles</div>
          <p className="feature-desc">
            Save your child's profile and we project their growth automatically — no re-measuring every visit.
          </p>
        </div>
        <div className="feature-card">
          <span className="feature-icon">🎁</span>
          <div className="feature-title">Buy ahead with confidence</div>
          <p className="feature-desc">
            Need to buy for Christmas or a birthday? Tell us the date and we'll recommend the right size for then.
          </p>
        </div>
      </section>

      <div className="brands-section" data-testid="brands-section">
        <p className="brands-label">Brands covered</p>
        <div className="brands-list">
          <span className="brand-pill highlight">Carter's</span>
          <span className="brand-pill highlight">H&M</span>
          <span className="brand-pill highlight">Zara</span>
          <span className="brand-pill highlight">Old Navy</span>
          <span className="brand-pill highlight">Gap Kids</span>
          <span className="brand-pill">Next</span>
          <span className="brand-pill">Tu (Sainsbury's)</span>
          <span className="brand-pill">Primark</span>
          <span className="brand-pill">Cat & Jack</span>
          <span className="brand-pill">Marks & Spencer</span>
          <span className="brand-pill">Nike Kids</span>
          <span className="brand-pill">Adidas Kids</span>
          <span className="brand-pill">Uniqlo</span>
          <span className="brand-pill">Lindex</span>
          <span className="brand-pill">KappAhl</span>
          <span className="brand-pill">Polarn O. Pyret</span>
          <span className="brand-pill">+ 20 more</span>
        </div>
      </div>

      <footer data-testid="footer">
        <div className="footer-links">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <a href="mailto:support@kidssizefinder.com">Support</a>
          <a href="https://www.tryoutgrow.com" target="_blank" rel="noopener noreferrer">OutGrow App</a>
        </div>
        <p className="footer-copy">© 2026 Outgrow Solutions Oy. All rights reserved. Made in Finland 🇫🇮</p>
      </footer>
    </>
  );
};

export default HomePage;
